import {
  FieldSwitch,
  FieldText,
  HelpIcon,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';

import {
  DispatchProps,
  StateProps,
} from 'components/settings/containers/sections/telephony/editNumberModal';
import { withPhoneNumbers, WithPhoneNumbersInjectedProps } from 'hocs';
import { validateName } from 'utils/formValidator';

import PrettyNumber from '../PrettyNumber';

import '../telephony.less';

type FormValuesT = {
  name: string;
  record_outbound_calls: boolean;
};

type PropsT = {
  initialValues: any;
  isShown: boolean;
  featureflags: {
    is_listen_in_allowed: boolean;
    is_callrecording_allowed: boolean;
  };
  handleSubmit: any;
  selectedNumber: any;
  updateNumber: any;
  fetchNumbers: () => void;
} & StateProps &
  DispatchProps &
  WithPhoneNumbersInjectedProps;

type StateT = {
  isDefaultChecked: boolean;
  isOutboundRecordingChecked: boolean;
  newLabel: string;
};

class EditNumberModal extends PureComponent<PropsT, StateT> {
  @boundMethod
  handleFormSubmit(values: FormValuesT) {
    const { name, record_outbound_calls } = values;
    const {
      phoneNumbers: { update },
      selectedNumber: { e164_format: number },
      hideEditNumberModal,
      fetchNumbers,
    } = this.props;

    if (number) {
      update({
        number,
        name,
        record_outbound_calls,
      })
        .then(hideEditNumberModal)
        .then(fetchNumbers)
        .catch((exception) => {
          console.error('edit number exception', exception);
        });
    }
  }

  render() {
    const {
      isShown,
      selectedNumber,
      featureflags,
      hideEditNumberModal,
      handleSubmit,
    } = this.props;

    const numberE164Format =
      selectedNumber && selectedNumber.e164_format
        ? selectedNumber.e164_format
        : '';

    let outboundNumberDescription = `Only number that are verified for outbound calling can enable call recording. When outbound call recording is enabled all outbound calls from the number ${numberE164Format} is recorded.`;
    let disabledOutbound = true;

    if (selectedNumber && selectedNumber.outgoing_functionality) {
      outboundNumberDescription = `Record all outbound calls made with phone number ${numberE164Format}.`;
      disabledOutbound = false;
    }

    if (featureflags.is_callrecording_allowed == false) {
      outboundNumberDescription = `Call recording is disabled on this organization.`;
      disabledOutbound = true;
    }

    return (
      <Modal isOpen={isShown} onClose={hideEditNumberModal}>
        <ModalHead title="Settings" onClose={hideEditNumberModal}>
          Change the settings of the phone number:{' '}
          <PrettyNumber number={selectedNumber} />
        </ModalHead>

        <ModalBody>
          <form
            onSubmit={handleSubmit(this.handleFormSubmit)}
            id="editNumberForm"
          >
            <div className="edit-number-modal__body">
              <Field
                label="Name"
                name="name"
                component={FieldText}
                type="text"
                placeholder="(e.g. Customer support)"
                helpIcon={{
                  title: 'Name',
                  text: 'Give this number a name so everyone on your team knows what this phone number will be used for (e.g. Customer Support, complaints, high-priority, etc.).',
                }}
                validate={validateName}
              />
              <div className="edit-number-modal__body-outbound">
                <p>
                  Record outbound calls
                  <span className="edit-number-modal__body-outbound__help">
                    <HelpIcon
                      title="Outbound call recording"
                      text={outboundNumberDescription}
                    />
                  </span>
                </p>
                <Field
                  label="Outbound call recording"
                  name="record_outbound_calls"
                  component={FieldSwitch}
                  type="checkbox"
                  placeholder="(e.g. Customer support)"
                  disabled={disabledOutbound}
                />
              </div>
            </div>
          </form>
        </ModalBody>

        <ModalFoot
          cancelOnClick={hideEditNumberModal}
          confirmOnClick={handleSubmit(this.handleFormSubmit)}
          confirmProps={{
            type: 'submit',
            form: 'editNumberForm',
          }}
          confirmName="Save"
        />
      </Modal>
    );
  }
}

const WrappedEditNumberModal = withPhoneNumbers(EditNumberModal);

export default reduxForm<any, any, any>({
  form: 'editNumberModal',
  enableReinitialize: true,
})(WrappedEditNumberModal);
